import type { ReactNode } from 'react';
import { useEffect, useRef } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../providers/AuthProvider';
import { ROUTES } from '../../routes/routes';

interface ProtectedRouteProps {
  children: ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();

  const isFirstMount = useRef(true);

  useEffect(() => {
    if (isFirstMount.current) {
      isFirstMount.current = false;

      if (!isAuthenticated) {
        console.log('Not authenticated, redirecting to login');
      } else {
        console.log('Authenticated as:', user?.email);
      }
    }
  }, [isAuthenticated, user]);

  if (!isAuthenticated) {
    // Redirect to login page with the return url
    return <Navigate to={ROUTES.login} state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
